import { HAUPT } from "./seitenOps";

/**
 * Kommentare hängen an Seiten des GESPEICHERTEN Dokuments. Baut der
 * Seiten-Organisator um (sortieren, löschen, einfügen), wandern sie beim
 * Speichern mit: alte Seite i → neue Seite `zuordnung[i]`, -1 = gelöscht
 * (der Kommentar behält seinen Text und steht dann „ohne Stelle“).
 *
 * Reine Funktionen — der Server bekommt das Ergebnis über
 * `PUT /documents/:id/kommentare/seiten`.
 */

/** Aus den Einträgen des Organisators: neue Seite n stammt aus `eintraege[n]`. */
export function kommentarZuordnung(
    eintraege: readonly { quelle: string; seite: number }[],
    alteSeitenzahl: number,
    haupt: string = HAUPT,
): number[] {
    const z = Array.from({ length: alteSeitenzahl }, () => -1);
    eintraege.forEach((e, neu) => {
        // Doppelt eingefügte Seite: der Kommentar bleibt an der ersten.
        if (e.quelle === haupt && e.seite >= 0 && e.seite < alteSeitenzahl && z[e.seite] === -1) z[e.seite] = neu;
    });
    return z;
}

/** Zwei Umbauten vor einem Speichern: Original → Runde 1 → Runde 2. */
export function verketteZuordnung(bisher: number[] | null, neu: number[]): number[] {
    if (!bisher) return neu;
    return bisher.map((p) => (p === -1 ? -1 : (neu[p] ?? -1)));
}

/** Welche Originalseite gerade an Position `angezeigt` steht — `null` bei eingefügten fremden Seiten. */
export function originalSeite(zuordnung: number[] | null, angezeigt: number): number | null {
    if (!zuordnung) return angezeigt;
    const i = zuordnung.indexOf(angezeigt);
    return i === -1 ? null : i;
}

/**
 * Hat der Kommentar eine Stelle im Dokument, wie es jetzt ist? Nein, wenn die
 * Stelle fehlt (Seite beim Umbau gelöscht) oder die Seite jenseits der
 * Seitenzahl liegt — etwa nach „Fassung wiederherstellen“ mit weniger Seiten.
 * `seitenzahl` null = (noch) unbekannt: dann zählt nur die fehlende Stelle.
 */
export function hatStelle(
    k: { seite: number | null; rect: readonly number[] | null },
    seitenzahl: number | null,
): boolean {
    if (k.seite === null || !k.rect) return false;
    return seitenzahl === null || k.seite < seitenzahl;
}

export function ohneStelle<T extends { seite: number | null; rect: readonly number[] | null }>(
    liste: readonly T[],
    seitenzahl: number | null,
): T[] {
    return liste.filter((k) => !hatStelle(k, seitenzahl));
}
